import { render, staticRenderFns } from "./component.vue?vue&type=template&id=533a5abb&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=533a5abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a5abb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533a5abb')) {
      api.createRecord('533a5abb', component.options)
    } else {
      api.reload('533a5abb', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=533a5abb&scoped=true&", function () {
      api.rerender('533a5abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/resource/component/core/dropdown-menu/component.vue"
export default component.exports